import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {TemplateURL} from 'commerce-sdk-isomorphic'

export const fetchContentAsset = async (contendId, {locale, getTokenWhenReady, c_v}) => {
    try {
        const appOrigin = getAppOrigin()
        const {commerceAPI} = getConfig().app
        const {parameters, proxyPath} = commerceAPI
        const {siteId} = parameters
        const accessToken = await getTokenWhenReady()

        const contentUrl = new TemplateURL(
            '/custom/headless/v1/organizations/{organizationId}/content/{contentId}',
            `${appOrigin}/${proxyPath}`,
            {
                origin: appOrigin,
                pathParams: {...parameters, proxyPath, contentId: contendId},
                queryParams: {siteId, locale, ...(c_v && {c_v})}
            }
        ).toString()

        const response = await fetch(contentUrl, {
            headers: {authorization: `Bearer ${accessToken}`}
        })

        if (!response.ok) {
            throw new Error(
                `Failed to fetch no hit results content data for locale ${locale}. Received the response: ${response.status} ${response.statusText}`
            )
        }

        return response.json()
    } catch (err) {
        console.error(err)
        return {}
    }
}
